/**
 *
 * Searchbox Block
 *
 * Simple UI interface events for the searchbox block
 */
const $         = require( 'jQuery' );


    var SearcboxBlock = function(el){
        this.$el               = $(el);
        this.$searchInput      = this.$el.find( '.itbl-b-searchbox__input' );
        this.$clearSearch      = this.$el.find( '.itbl-b-searchbox__clear' );


        this.init();
    };

    SearcboxBlock.prototype.init = function(){

        this.$clearSearch.on( 'click', this.event__handleInputClear.bind( this ) );


    };

    SearcboxBlock.prototype.event__handleInputClear = function( event ){

        event.preventDefault();

        //when the  clear button is clicked, we clear and set the focus again
        $( this.$searchInput )
            .val( '' )
            .focus();

    };

    $(document).ready(function(){
        $('.js-searchbox-block').each(function(){
            new SearcboxBlock(this);
        });

    });
